import { createRouter, createWebHistory } from "vue-router";
import HomePage from "../views/HomePage.vue";
import AboutPage from "@/views/AboutPage.vue";
import TheHub from "@/views/TheHub.vue";
import ServicesPage from "@/views/ServicesPage.vue";
import ContactPage from "@/views/ContactPage.vue";
import MshelHomes from "@/views/MshelHomes.vue";
import MshelConstruction from "@/views/MshelConstruction.vue";
import MshelFoundation from "@/views/MshelFoundation.vue";
import MshelPrints from "@/views/MshelPrints.vue";
import LisaSuites from "@/views/LisaSuites.vue";
import MshelBlocksAndMachineries from "@/views/MshelBlocksAndMachineries.vue";
import MshelLogistics from "@/views/MshelLogistics.vue";
import MshelConsult from "@/views/MshelConsult.vue";

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes: [
      {
        path: "/",
        name: "home",
        component: HomePage,
      },
      {
        path: "/about-us",
        name: "about-us",
        component: AboutPage,
      },
      {
        path: "/the-hub",
        name: "the-hub",
        component: TheHub,
      },
      {
        path: "/services",
        name: "services",
        component: ServicesPage,
      },
      {
        path: "/contact-us",
        name: "contact-us",
        component: ContactPage,
      },
      {
        path: "/mshel-homes",
        name: "mshel-homes",
        component: MshelHomes,
      },
      {
        path: "/mshel-construction",
        name: "mshel-construction",
        component: MshelConstruction,
      },
      {
        path: "/mshel-foundation",
        name: "mshel-foundation",
        component: MshelFoundation,
      },
      {
        path: "/mshel-prints",
        name: "mshel-prints",
        component: MshelPrints,
      },
      {
        path: "/lisa-suites",
        name: "lisa-suites",
        component: LisaSuites,
      },
      {
        path: "/mshel-blocks-and-machineries",
        name: "mshel-blocks-and-machineries",
        component: MshelBlocksAndMachineries,
      },
      {
        path: "/mshel-logistics",
        name: "mshel-logistics",
        component: MshelLogistics,
      },
      {
        path: "/mshel-consult",
        name: "mshel-consult",
        component: MshelConsult,
      },
    ],
  });
  
  export default router;